// extracted by mini-css-extract-plugin
export default {"active":"Navbar_active__ZydkP","inactive":"Navbar_inactive__o34Dz"};